import { Box, Checkbox, FormControl, FormLabel, Stack, Text, useToast } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { FaUserAlt } from 'react-icons/fa';

import HeaderSectionMobilePage from '../../../../../components/Mobile/headerSection';
import InputMobile from '../../../../../components/Input/Mobile';
import AttachmentDocumentProtocol from '../../../../../components/Mobile/attachmentButtonFile';
import { IDataToRegistration } from '../../../../../services/hooks/CandidateArea/useGetDataToRegistration';
import { useQueryClient } from '@tanstack/react-query';
import { IGetRegistration } from '../../../../../services/hooks/Registration/useGetRegistration';
import { UseRegistration } from '../../../../../Store/useRegistration';
import { handleDeleteAttach } from '../../../../../utils/functions';

interface IFormContext {
  selectedProtocol: boolean[];
  social_name_protocol: string[];
  protocol_attachmentFile: File[];
}

interface IOwnProps {
  selectiveProcess?: IDataToRegistration;
}

const RegistrationProtocolsMobilePage: React.FC<IOwnProps> = ({ selectiveProcess }) => {
  const { formState, register, watch } = useFormContext<IFormContext>();
  const selecteds = watch('selectedProtocol') || [];
  const accent = '#222';
  const { registrationId } = UseRegistration();

  const toast = useToast();

  const queryClient = useQueryClient();
  const protocolCached = queryClient.getQueryData<IGetRegistration>([
    'registration_data',
    registrationId ?? '',
  ])?.protocol;

  return (
    <Stack mt={1}>
      <HeaderSectionMobilePage>Protocolos</HeaderSectionMobilePage>
      <Stack>
        {selectiveProcess?.protocol?.map((protocol, index) => {
          const isChecked = !!selecteds[index];
          const errorMessage = formState?.errors?.social_name_protocol?.[index]?.message as string;

          const listAttachment = protocolCached?.find((cached) => cached.protocol_type.id === protocol.id);

          const onDeleteAttachment = async (id: string) => {
            await handleDeleteAttach(id, toast).then(() => {
              queryClient.setQueryData<IGetRegistration>(['registration_data', registrationId ?? ''], (data) => {
                if (!data) return data;

                return {
                  ...data,
                  protocol: data.protocol.map((registrationProtocol) =>
                    registrationProtocol.protocol_type.id === protocol.id
                      ? {
                          ...registrationProtocol,
                          attachments: registrationProtocol.attachments?.filter((file) => file.id !== id) || [],
                        }
                      : registrationProtocol,
                  ),
                };
              });
            });
          };

          return (
            <Box
              key={protocol.id}
              p={2}
              borderWidth="1px"
              borderRadius="md"
              bg={isChecked ? 'gray.50' : 'white'}
              transition="0.3s"
              shadow={isChecked ? 'md' : 'sm'}
            >
              <Checkbox
                {...register(`selectedProtocol.${index}` as const)}
                isChecked={isChecked}
                value={protocol.id}
                size="md"
                colorScheme="green"
                aria-label={`Selecionar protocolo ${protocol.name}`}
              >
                {protocol.name}
              </Checkbox>

              {isChecked && protocol.is_social_name && (
                <Stack mt={2} spacing={3}>
                  <FormControl>
                    <FormLabel fontWeight="normal" fontSize="sm">
                      O nome social é a forma de tratamento que reflete a identidade de gênero da pessoa, especialmente
                      importante para pessoas transgênero, travestis e não-binárias.
                    </FormLabel>

                    <InputMobile
                      name={`social_name_protocol.${index}`}
                      placeholderLabel="Nome social"
                      iconLeft={<FaUserAlt size={12} color={accent} />}
                    />

                    {errorMessage && <Text color="#E53E3E">{errorMessage}</Text>}
                  </FormControl>

                  {protocol.max_attached > 0 && (
                    <AttachmentDocumentProtocol
                      buttonText="Selecione os documentos"
                      inputName="protocol_attachmentFile"
                      index={index}
                      sentAttachments={listAttachment?.attachments?.map((attach) => ({
                        id: attach.id,
                        name: attach.name,
                        url: attach.url,
                        created_at: attach.created_at_patern,
                      }))}
                      onDeleteAttachment={onDeleteAttachment}
                    />
                  )}
                  {protocol.max_attached > 0 && (
                    <AttachmentDocumentProtocol
                      buttonText="Selecione sua foto"
                      inputName="protocol_photo"
                      multiple={false}
                      index={index}
                      sentAttachments={
                        listAttachment && [
                          {
                            id: listAttachment?.id,
                            name: 'Visulizar foto',
                            url: listAttachment?.photo || '',
                          },
                        ]
                      }
                      onDeleteAttachment={() => {}}
                    />
                  )}
                </Stack>
              )}
            </Box>
          );
        })}
      </Stack>

      {formState.errors.selectedProtocol && (
        <Text color="#E53E3E">{formState.errors.selectedProtocol.message as string}</Text>
      )}
    </Stack>
  );
};

export default RegistrationProtocolsMobilePage;
